"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hooks = require("../../hooks");

var determineBreakPoint = function determineBreakPoint(width) {
  var breakPoints = [{
    width: 48,
    name: 'sm'
  }, {
    width: 60,
    name: 'md'
  }, {
    width: 72,
    name: 'lg'
  }, {
    width: 84,
    name: 'xl'
  }, {
    width: 96,
    name: 'xxl'
  }];
  var widthAsEm = width / 16;
  return breakPoints.reduce(function (accu, i) {
    return widthAsEm < i.width ? accu : i;
  }, {
    width: 0,
    name: 'xs'
  });
};

var Media = function Media(_ref) {
  var breakpoints = _ref.breakpoints,
      children = _ref.children;

  var _useWindowSize = (0, _hooks.useWindowSize)({}),
      width = _useWindowSize.width,
      height = _useWindowSize.height;

  var _determineBreakPoint = determineBreakPoint(width),
      breakPoint = _determineBreakPoint.name;

  return breakpoints.includes(breakPoint) ? children : null;
};

var _default = Media;
exports.default = _default;